/** Table legend for drivers and vehicle list */
import React from "react";
import { useTranslation } from "react-i18next";
import { BadgeStatus, EntityType } from "shared/constants";
import { getBadgeStatus } from "views/contractView/shared/driverVehicleBadgeStatus";
import DsBadge from "components/DsBadge";

interface IDriverVehicleListTableLegendProps {
    tableType: BadgeStatus,
    entityType: EntityType.VEHICLE | EntityType.DRIVER,
    delegation?:boolean
}
const DriverVehicleListTableLegend: React.FC<IDriverVehicleListTableLegendProps> = (props): JSX.Element => {
    const { t } = useTranslation(['contract']);
    const { tableType, entityType } = props;

    const translationPrefix: string = entityType === EntityType.VEHICLE ? 'vehicle.vehicleList' : 'drivers.driverList';
    const translationSuffix: string = tableType === BadgeStatus.NOT_CREDITED ? "notCredited" : "credited";
    return (
        <div style={{ display: "flex", alignItems: "center", gap: "12px", marginTop: "24px" }}>
            <DsBadge notificationStatus={getBadgeStatus(BadgeStatus.APPROVED, tableType)} isSmall={true}/>
            <span className="legendaLabel--contract">
                {props.delegation?t('transporter.transporterList.tableLegend.0'):t(translationPrefix + '.tableLegend.' + translationSuffix + '.0') /*Approvato*/}
            </span>

            <DsBadge notificationStatus={getBadgeStatus(BadgeStatus.TO_CREDIT, tableType)} isSmall={true}/>
            <span className="legendaLabel--contract">
                {props.delegation?t('transporter.transporterList.tableLegend.1'):t(translationPrefix + '.tableLegend.' + translationSuffix + '.1') /*In attesa*/}
            </span>

            <DsBadge notificationStatus={getBadgeStatus(BadgeStatus.EXPIRED, tableType)} isSmall={true}/>
            <span className="legendaLabel--contract">
                {props.delegation?t('transporter.transporterList.tableLegend.2'):t(translationPrefix + '.tableLegend.' + translationSuffix + '.2') /*Non accreditato||approvato / Scaduto*/}
            </span>
        </div>
    );
}

export default DriverVehicleListTableLegend;